// @module NXTurn.ShoppingExtensions.LoginRegister
define('C3.ShoppingExtensions.NewArrivals.Home.View'
,	[
	  'c3_shoppingextensions_newarrivals_home.tpl'
	
	,   'AjaxRequestsKiller'
	//,   'SCView'
	,   'C3.ShoppingExtensions.NewArrivals.Collection'
	,   'C3.ShoppingExtensions.NewArrivals.Home.Items.CellView'
	,   'c3_shoppingextensions_newarrivals_home_items.tpl'
	,   'item_relations_cell.tpl'
	,   'item_relations_row.tpl'
	,   'Backbone.CollectionView'
	,  'facets_item_cell_grid.tpl'
    ,  'facets_items_collection_view_cell.tpl'
    ,  'facets_items_collection_view_row.tpl'
    ,   'facets_items_collection.tpl'
    ,   'Utils'
    ]
, function (
	   c3_shoppingextensions_newarrivals_home_tpl
	
	
	,   AjaxRequestsKiller
	//,   SCViewModule
	,   Collection
	,   C3ShoppingExtensionsCarouselItemsCellView
	,   c3_shoppingextensions_newarrivals_home_items_tpl
	,   item_relations_cell_tpl
	,   item_relations_row_tpl
	,   BackboneCollectionView
	,  facets_item_cell_grid_tpl
    ,  facets_items_collection_view_cell_tpl
    ,  facets_items_collection_view_row_tpl
    ,  facets_items_collection_tpl
    ,  Utils
)
{
    'use strict';

	// @class NXTurn.ShoppingExtensions.LoginRegister.View @extends Backbone.View
	return Backbone.View.extend({

		template: c3_shoppingextensions_newarrivals_home_tpl

	,	initialize: function (options) {
		    this.options = options;
			this.application = options.application;
	        this.container = options.container;

	        this.slideWidth = options.slideWidth;
			this.maxSlides = options.maxSlides;
			this.searchID = options.savedsearchid;
			this.tradeinManufacturerId = options.tradeinmanufacturerid;
			this.tradeinCategoryId = options.tradeincategoryid;
			this.configuration = options.configuration;

			this.once('afterCompositeViewRender', this.initSlider, this);
		}

	,   initSlider: function initSlider() {

			var self = this;
	       // if(jQuery(window).width() >= 760) //using 760 due to Tablet as its showing to start from 760
          //  {
           // const { siteSettings } = this.application.getConfig();
            	
           // setTimeout(function() {
                const carousel = self.$el.find('[data-type="carousel-items"]');
                //console.log(carousel)
                const {
                    siteSettings,
                    imageSizeMapping,
                    bxSliderDefaults
                } = self.options.application.getConfig();

                if (jQuery(window).width() >= 760 && siteSettings.imagesizes) {
                    const img_min_height = (_.where(siteSettings.imagesizes, {
                        name: imageSizeMapping.thumbnail
                    })[0]).maxheight;

                    carousel
                        .find('.item-relations-related-item-thumbnail')
                        .css('minHeight', img_min_height);
                }

                if(self.responseItems && self.responseItems.length > 3)
                	bxSliderDefaults.controls = true;
                else
                	bxSliderDefaults.controls = false;

                bxSliderDefaults.slideWidth = self.slideWidth;
                bxSliderDefaults.maxSlides = self.maxSlides;
                bxSliderDefaults.hideControlOnEnd = true;
                /*bxSliderDefaults.prevText = '<a data-click="left-click" data-action="home-newarr-click" class="carousel-items-prev-icon"><img src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg"></a>';*/
                bxSliderDefaults.prevText = '<a data-click="home-newarr-left-click" data-action="home-newarr-click" class="home-new-arrivals carousel-items-prev-icon"><img class="left-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg"></a>';
                bxSliderDefaults.nextText = '<a data-click="home-newarr-right-click" data-action="home-newarr-click" class="home-new-arrivals carousel-items-next-icon"><img class="right-icon-img" src="/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg"></a>';
                //bxSliderDefaults.touchEnabled = false;
                
                bxSliderDefaults.infiniteLoop = false;
                //console.log(bxSliderDefaults)
                Utils.initBxSlider(carousel, bxSliderDefaults);
             // });
          //  }
    }	

	,	bindings: {
		}
    
    ,   events: {
    	'click [data-action="home-newarr-click"]': 'arrowClicked'
    }

    ,   arrowClicked: function arrowClicked(e){
    	
    	const anchor = jQuery(e.currentTarget)
    	,     data_attr = anchor.attr('data-click')
	    ,     sibling = anchor.siblings()

	    
	    if(data_attr == 'home-newarr-right-click')
	    {
	    	//console.log(anchor.hasClass('disabled'))
	    	//console.log(anchor.hasClass('disabled'))
	    	//console.log(sibling.hasClass('disabled'))
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.home-new-arrivals.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}

	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.home-new-arrivals.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')	    		
	    	}
	    	else
	    	{
	    		$('.home-new-arrivals.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow.svg')
	    	}
	    }
	    else if(data_attr == 'home-newarr-left-click')
	    {
	    	if(anchor.hasClass('disabled'))
	    	{
	    		$('.home-new-arrivals.carousel-items-prev-icon .left-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Left Arrow-Grey.svg')
	    	
	    	}
	    	if(sibling.hasClass('disabled'))
	    	{
	    		$('.home-new-arrivals.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow-Grey.svg')
	    	}
	    	else
	    	{
	    		$('.home-new-arrivals.carousel-items-next-icon .right-icon-img').attr('src','/SSP Applications/AAMedicalStore/AAMedicalStore/img/Right Arrow.svg')
	    	}
	    }
	   
    }
	, 	childViews: {
			'NewArrvials.Home.Items': function ()
      		{
     			var self = this;
     			//console.log(this.itemIDs)
		         /*return new CarouselItemsView({
			          itemsIds: this.itemIDs//self.itemIDs
			        , application: self.application
			        , slideWidth: this.slideWidth
			        , maxSlides: this.maxSlides
			        , responseResults : this.responseItems
			        , origin : this.options.origin
			        , container : this.container
			        , configuration : this.configuration
			        });*/

     			return new BackboneCollectionView({
	                application: this.application,
	                collection: this.responseItems,
	                viewsPerRow: Infinity,
	                childView: C3ShoppingExtensionsCarouselItemsCellView,
	                cellTemplate: item_relations_cell_tpl,
            		rowTemplate: item_relations_row_tpl,
	                template: c3_shoppingextensions_newarrivals_home_items_tpl,
		            childViewOptions: {
	                    origin: 'newarrivals-home',
	                    hideArrows : this.responseItems.length <= 4 ? true : false,
	                    application : this.application,
	                    container : this.container,
	                    configuration : this.configuration
	                }
            	});

     			/*var isPhoneDevice = Utils.isPhoneDevice()
                        ,   viewsPerRow = 4;

                        if(isPhoneDevice)
                        viewsPerRow = 2;*/

            	/*return new BackboneCollectionView({
                application: this.application,
                collection: this.responseItems,
                viewsPerRow: viewsPerRow,
                childTemplate: facets_item_cell_grid_tpl,
                childView: C3ShoppingExtensionsCarouselItemsCellView,
                cellTemplate: facets_items_collection_view_cell_tpl,
                rowTemplate: facets_items_collection_view_row_tpl,
                template: facets_items_collection_tpl,
                childViewOptions:{
                    origin: 'newarrivals-home',
                    configuration : this.configuration,
                    application : this.application
                }
            });*/
      		}
		}

	,   render : function()
	    {
	    	
	    	var self = this;
	    	var collection = new Collection();

	    	collection.fetch({ data:{       
		        pageNumber: 1,
		        resultsPerPage: 12,
		        filters: ''
		      } }).done(function(res) {
		     	
		     	var newArrivalData = res.newArrivalData
		     	,   newArrivalItems = newArrivalData.items;

		     	self.responseItems = newArrivalItems;
				self._render();
		      });  
	    	

	    } 	

		//@method getContext @return NXTurn.ShoppingExtensions.LoginRegister.View.Context
	,	getContext: function getContext()
		{
			var itemIds = this.responseItems;
			return {
				hasProducts : itemIds ? (itemIds.length > 0 ? true : false) : []
			};
		}
	});
});
